import React from 'react';

import { AutoComplete, Input, message } from 'antd';

import sessionManager, { eVariableType } from '../../SessionManager';
import api from '../../api';
import stringres from '../../translations/stringres';

export default function CmbClienti(props) {
    const { onSelected } = props;
    const [suggestions, setSuggestions] = React.useState([]);

    async function handleSearch(value) {
        try {
            if (value != null && value.length > 2) {
                const result = await api.get(
                    'CRM/Clienti?indice=0&numeroRecord=10&idSocieta=' +
                        sessionManager.get(eVariableType.IDSocieta) +
                        '&ragioneSociale=' +
                        value
                );
                if (result != null && result.data != null) {
                    setSuggestions(result.data);
                }
            }
        } catch (error) {
            message.error(error.message.response.data.message);
        }
    }

    async function OnSelect(item, opt) {
        const rx = suggestions.filter((x) => x.codCliente === opt.key);
        if (rx != null) onSelected(rx[0]);
    }

    function onChange(e) {
        if (e.target.value === null || e.target.value === '') onSelected(null);
    }

    return (
        <AutoComplete
            key="codCliente"
            onSearch={handleSearch}
            options={suggestions.map((customer) => ({
                value: customer.ragioneSociale,
                label: customer.ragioneSociale,
                key: customer.codCliente,
            }))}
            onSelect={OnSelect}
            value={props.value}
        >
            <Input size="large" onChange={onChange} placeholder={stringres.t('campodiricercaclienti')}></Input>
        </AutoComplete>
    );
}
